import type { DocxFormData, DocxFormSaveValues } from "../../components/doctohtml/collectDocxFormValues";
import { saveItem } from "../../localdb/indexeddb";
import { apiClient } from "../client";

export interface SaveDocxFormResponse {
  message: string;
  fileId: string;
}

/**
 * Save DOCX form data
 * Sends a POST/PATCH request to save DOCX form data
 */
export async function saveDocxForm(
  fileId: string,
  formData: DocxFormSaveValues,
  emailId: string,
  memberId: string
): Promise<SaveDocxFormResponse> {
  try {
    const payload = { rows: formData.tableInfo, emailId, memberId, fileId };
    const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;

    if (!isOnline) {
      // TODO: Implement offline storage for DOCX forms if needed
      return {
        message: "DOCX form data saved to local storage successfully.",
        fileId,
      };
    } else {
      // Update this endpoint URL when backend provides the actual DOCX save endpoint
      const response = await apiClient.patch(
        `/docx/save`,
        payload
      );
      const backendMessage =
        (response?.data && (response.data as { message?: string }).message) || "";

      return {
        message: backendMessage || "DOCX form data saved successfully.",
        fileId,
      };
    }
  } catch (error) {
    throw error;
  }
}


async function SubmitFormData(data: any, fieldId: string, type: string) {
  // Save each form from the response to IndexedDB

  await saveItem("submittedFormKeyData", {
    id: fieldId,
    data: data,
    type: type
  });

}

/**
 * Submit DOCX form data
 * Sends a POST request to submit DOCX form and download the filled document
 */
export async function submitDocxForm(
  fileId: string,
  formData: DocxFormData,
  isAdminSubmit: boolean = false
): Promise<SaveDocxFormResponse> {
 try {
    const payload = { fileId, rows: formData.rows };
    const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
    if (!isOnline) {
      await SubmitFormData(payload, fileId, "docx");
      return {
        message: "Form submitted successfully.",
        fileId,
      }
    }
    const response = await apiClient.post<Blob>(
      `/docx/fill`,
      payload,
      { responseType: "blob" }
    );
    if (true) {
      const blob = response?.data;
      if (blob && blob.size > 0) {
        const url = window.URL.createObjectURL(blob);
        // Try to extract filename from Content-Disposition header
        const dispo = (response.headers as Record<string, string | undefined>)["content-disposition"];
        let fileName = `filled-${fileId}.docx`;
        if (dispo) {
          const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(dispo);
          const name = match?.[1] || match?.[2];
          if (name) fileName = decodeURIComponent(name);
        }
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return {
          message: `Downloaded ${fileName}`,
          fileId,
        };
      }
      return {
        message: "Form submitted, but no file received.",
        fileId,
      }
    }
    return {
      message: "Form submitted successfully.",
      fileId,
    }

  } catch (error) {

    throw error;
  }
}
